import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import pHistoriquePaiement from '@/components/comptable/dettes/historique-paiement';
import $ from 'jquery'

extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});

export default {
    name: 'dettes',
    components: {
        ValidationProvider, ValidationObserver,
        pHistoriquePaiement
    },
    props: [],
    data() {
        return {
            is_empty: false,
            is_loading: true,
            solde_is_less: false,
            fields: [
                { key: 'num_facture', label: 'N° facture' }, { key: 'echeance', label: 'Echéance' },
                { key: 'ligne', label: 'Ligne budgétaire' }, 'fournisseur', 'montant', { key: 'reglement', label: 'Payé / Restant' },
                { key: 'action', label: 'Action.s' } 
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            modal_title: 'Nouvelle dette',
            dette: {
                dette_id: 0,
                ref_facture: '',
                date: '',
                montant: '',
                fournisseur: '',
                ligne_budgetaire: '',
                echeance: ''
            },
            save_loading: false,
            ligne_budget: [],

            months: [
                { id: '', lib: "Filtrer" },
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),
            curr_month: {
                id: '', lib: "Filtrer"
            },          // Current month of the year
            filter_date: '',
            is_exist: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,
            dette_globale: 0,

            dette_statut: [
				{
                    libelle: 'Dette en attente',
                    id: '1',
                },
                {
                    libelle: 'Dette payée',
                    id: '2',
                }
            ],
            statut_dette: '',
            dette_type_period: '',
            dette_period: '',

            dette_a_payer: {
                dette_id: '',
                ref_facture: '',
                ligne_id: 0,
                ligne_budgetaire: '',
                montant: '',
                montant_a_payer: '',
            },
            amount_is_greater: false,
            dette_historique: {
                ligne_id: '',
                dette_id: '',
                ref_facture: '',
            },
            can_update_loading: true,

            histo_is_empty: false,
            histo_is_loading: true,
            histo_fields: [
                'date', { key: 'montant_initial', label: 'Montant initial' },
                { key: 'montant_regle', label: 'Montant réglé' }, { key: 'montant_restant', label: 'Montant restant' }
            ],
            histo_filter: "",
            dette_view: {
                id: '',
                ref_facture: '',
                libelle: ''
            },
            m_title: '',
            is_historique: false,

            // -----------------
            inputContainerEl: '',
            textInputEl: '',
            suggestionEl: '',
            svgTabIcon: '',
            svgEnterIcon: '',
        
            ENTER_KEYCODE: '',
            TAB_KEYCODE: '',
            BACKSPACE_KEYCODE: '',
            UP_ARROW_KEYCODE: '',
            DOWN_ARROW_KEYCODE: '',
        }
    },

    watch: {
        filter_date() {
            this.dette_type_period = 2
            this.dette_period = this.filter_date
            var data = {
                statut: 1,                  //  1 => en attente | 2 => payée
                type_period: 2,
                period: this.filter_date
            }
            this.getListeDettes(data)
        },

        curr_month() {
            this.dette_type_period = 1
            this.dette_period = this.curr_month['id']
            var data = {
                statut: 1,                  //  1 => en attente | 2 => payée
                type_period: 1,
                period: this.curr_month['id']
            }
            this.getListeDettes(data)
        },

        statut_dette() {
            if (this.statut_dette.id == 1) {
                this.fields = [
                    { key: 'num_facture', label: 'N° facture' }, 'date', { key: 'echeance', label: 'Echéance' },
                    { key: 'ligne', label: 'Ligne budgétaire' }, 'fournisseur', 'montant', { key: 'action', label: 'Action.s' }
                ]
            } else {
                this.fields = [
                    { key: 'num_facture', label: 'N° facture' }, { key: 'ligne', label: 'Ligne budgétaire' }, 
                    'fournisseur', 'montant', { key: 'montant_regle', label: 'Montant réglé' },
                    { key: 'montant_reste', label: 'Montant restant' }, { key: 'action', label: 'Action.s' }
                ]
            }

            
            
            var data = {
                statut: parseInt(this.statut_dette.id),                  //  1 => en attente | 2 => payée
                type_period: this.dette_type_period,
                period: this.dette_period
            }
            this.getListeDettes(data)
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        liste_all_ligne_budgetaire() {
            return this.$store.getters['liste_all_ligne_budgetaire']
        },

        liste_fournisseurs() {
            return this.$store.getters['liste_fournisseurs']
        },

        liste_dettes() {
            return this.$store.getters['liste_dettes']
        },

        c_rows() {
            return this.liste_dettes.length
        },

        dette_est_paye() {
            return this.$store.getters['dette_est_paye']
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
         monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        liste_historique_paiement_dette() {
            return this.$store.getters['liste_historique_paiement_dette']
        },

        histo_rows() {
            return this.liste_historique_paiement_dette.length
        },

        dette_montant_restant() {
            return this.$store.getters['dette_montant_restant']
        },

        solde_tresorier() {
            return this.$store.getters["solde_tresorier"];
        },

        liste_ligne_budgetaire_by_role() {
            return this.$store.getters['liste_ligne_budgetaire_by_role']
        },

        solde_restant_ligne_budgetaire() {
            return this.$store.getters['solde_restant_ligne_budgetaire']
        },
    },
    mounted() {
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1
                this.can_view_reglement_dette = true
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3
            } else if (this.activeRole.nom == 'ROLE_TRESORERIE') {
                this.compte_id = 6
            }
        }

        // this.curr_month = this.monthOfYear[this.date.getMonth()]
        var data = {
            statut: 1,                  //  1 => en attente | 2 => payée
            type_period: '',
            period: ''
        }
        this.getListeDettes(data)

        this.$store.dispatch('getListeFournisseur')

        this.$store.dispatch('getAllLigneBudgetaire')

        // this.$store.dispatch('getSoldeTresorier', this.compte_id)
    },
    methods: {
        getListeDettes(data) {
            
            this.dette_globale = 0
            this.is_loading = true

            this.$store.dispatch('getListeDette', data).then(() => {
                if (this.liste_dettes.length > 0) {
                    this.is_empty = false

                    this.liste_dettes.forEach((el) => {
                        this.dette_globale += parseInt(el.montant)
                    })
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
            })
        },

        getListeHistorique(data) {
            this.histo_is_loading = true
            this.$store.dispatch('getListeHistoriqueDette', data).then(() => {
                if (this.liste_historique_paiement_dette.length > 0) {
                    this.histo_is_empty = false
                } else {
                    this.histo_is_empty = true
                }

                this.histo_is_loading = false
            })
        },

        clearError() {
            this.is_exist = false

            this.amount_is_greater = false
            this.solde_is_less = false
        },

        async save() {
            const isValid = await this.$refs.dette_form.validate();
            if (!isValid) {
                return;
            }
            this.save_loading = true

            var data = {
                dette_id: this.dette.dette_id,
                ref_facture: this.dette.ref_facture,
                date: this.dette.date,
                montant: this.dette.montant,
                fournisseur: this.dette.fournisseur,
                ligne_budgetaire: this.dette.ligne_budgetaire.id,
                echeance: this.dette.echeance
            }

            this.$store.dispatch('saveDette', data).then((response) => {
                if (response > 0) {
                    this.successToast("Dette ajoutée avec succès")

                    this.dette = {
                        dette_id: '',
                        ref_facture: '',
                        date: '',
                        montant: '',
                        fournisseur: '',
                        ligne_budgetaire: '',
                        echeance: ''
                    }
                    this.$refs.dette_form.reset()
                    this.$refs.add_dette.click()

                    this.dette_type_period = 1
                    this.dette_period = this.curr_month['id']
                    var data = {
                        statut: 1,                  //  1 => en attente | 2 => payée
                        type_period: 1,
                        period: this.curr_month['id']
                    }
                    this.getListeDettes(data)
                } else {
                    this.is_exist = true
                }

                this.save_loading = false
            })
        },

        newDette() {
            this.dette = {
                dette_id: 0,
                ref_facture: '',
                date: '',
                montant: '',
                fournisseur: '',
                ligne_budgetaire: '',
                echeance: ''
            }
            this.$refs.dette_form.reset()
        },

        edit(data) {
            this.dette = {
                dette_id: data.id,
                ref_facture: data.ref_facture,
                date: data.date,
                montant: data.montant,
                fournisseur: data.fournisseur,
                ligne_budgetaire: {
                    id: data.ligne_id,
                    libelle: data.libelle
                },
                echeance: data.date_echeance
            }

            this.modal_title = 'Modifier dette'
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        /**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.to_be_deleted = {
                id: data.id,
                libelle: data.ref_facture
            }
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé 
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('removeDette', this.to_be_deleted).then((response) => {
                    if (response > 0) {
                        this.successToast('Dette supprimée avec succès')
                    }
                    this.del_loading = false;
                    this.is_confirm = false

                    this.dette_type_period = 1
                    this.dette_period = this.curr_month['id']
                    var data = {
                        statut: 1,                  //  1 => en attente | 2 => payée
                        type_period: 1,
                        period: this.curr_month['id']
                    }

					this.getListeDettes(data)
					this.$refs.del_dette.click()
                })
            }
        },

        dettePaie(data) {
            
            this.m_title = 'Paiement de dette'
            this.is_historique = false
            this.dette_a_payer = {
                dette_id: data.id,
                ref_facture: data.ref_facture,
                ligne_id: data.ligne_id,
                ligne_budgetaire: data.libelle,
                montant_du: data.montant,
                montant_a_payer: '',
            }

            this.dette_view =  {
                id: data.id,
                ref_facture: data.ref_facture,
                libelle: data.libelle
            }
            $('.histo').fadeOut(500)
            setTimeout(() => {
                $('.is-paiement').fadeIn()
            }, 500);
            
            const params = {
                month: (this.date.getMonth()+1),       // mois courant
                role_id: 14,
                ligne_id: data.ligne_id
            }
            this.$store.dispatch('getSoldeCourantLigneBudgetaire', params)
        },

        async payer() {
            const isValid = await this.$refs.reglement_form.validate();
            if (!isValid) {
                return;
            }

            if (this.dette_a_payer.montant_a_payer > this.dette_a_payer.montant_du) {
                this.amount_is_greater = true
                return;
            }

            // Verifier le solde disponible pour regler la dette
            if (this.solde_restant_ligne_budgetaire.solde_restant < this.dette_a_payer.montant_a_payer) {
                this.solde_is_less = true
                return;
            }

            this.save_loading = true

            var commentaire = ''
            if ( (this.dette_a_payer.montant_du - this.dette_a_payer.montant_a_payer) == 0 ) {
                commentaire = 'Solde de la facture '+this.dette_a_payer.ref_facture
            } else {
                commentaire = 'Acompte de la facture '+this.dette_a_payer.ref_facture
            }

            var data = {
                data_type: "reglement_dette",
                type_operation: 2,
                source: this.compte_id,
                user_id: this.userCredentials.user.id,
                dette_id: this.dette_a_payer.dette_id,
                ref_facture: this.dette_a_payer.ref_facture,
                ligne_budgetaire: this.dette_a_payer.ligne_budgetaire,
                ligne_budgetaire_id: this.dette_a_payer.ligne_id,
                montant_du: this.dette_a_payer.montant_du,
                montant_a_payer: parseInt(this.dette_a_payer.montant_a_payer),
                commentaire: commentaire
            }

            this.$store.dispatch('saveReglementDette', data).then((response) => {
                if (response.success) {
                    this.successToast("Dette réglée avec succès")

                    this.$refs.reglement_form.reset()
                    this.$refs.close_pay.click()
                    const qdata = {
                        statut: 1,                  //  1 => en attente | 2 => payée
                        type_period: 1,
                        period: this.curr_month['id']
                    }

                    this.getListeDettes(qdata)
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        },

        checkDettePaiement(dette_id) {
            this.can_update_loading = true
            this.$store.dispatch('checkIfDetteIsPaid', dette_id).then(() => {
                this.can_update_loading = false
            })
        },

        viewHistoriquePaiement(data) {
            this.m_title = 'Historique de paiement'
            this.is_historique = true

            this.dette_historique = {
                ligne_id: data.ligne_id,
                dette_id: data.id,
                ref_facture: data.ref_facture,
                ligne_budgetaire: data.libelle,
            }

            this.dette_view = data

            var q_data = {
                dette_id: data.id,
                type_period: 2,
                period: data.date
            }
            // var q_data = {
            //     dette_id: data.id,
            //     type_period: this.dette_type_period,
            //     period: this.dette_period
            // }
            this.getListeHistorique(q_data)

            this.getDetteMontantRestant(data.id)

            
            $('.is-paiement').fadeOut(500)
            setTimeout(() => {
                $('.histo').fadeIn()
            }, 500);
        },

        goToHistorique(data) {
            this.m_title = 'Historique de paiement'
            this.is_historique = true

            this.dette_historique = {
                ligne_id: data.ligne_id,
                dette_id: data.id,
                ref_facture: data.ref_facture,
                ligne_budgetaire: data.libelle,
            }

            var q_data = {
                dette_id: data.id,
                type_period: 2,
                period: data.date
            }
            this.getListeHistorique(q_data)

            this.getDetteMontantRestant(data.id)

            
            $('.is-paiement').fadeOut(500)
            setTimeout(() => {
                $('.histo').fadeIn()
            }, 500);
        },

        getDetteMontantRestant(dette_id) {
            this.$store.dispatch('getDetteMontantRestant', dette_id)
        },

        reglerDette(data, montant_initial) {
            console.log("rg: ",data);
            
            this.m_title = 'Paiement de dette'
            this.is_historique = false
            this.dette_a_payer = {
                dette_id: data.dette_id,
                ref_facture: data.ref_facture,
                ligne_budgetaire: data.ligne_budgetaire,
                ligne_id: data.ligne_id,
                montant_du: montant_initial,
                montant_a_payer: '',
            }

            $('.histo').fadeOut(500)
            setTimeout(() => {
                $('.is-paiement').fadeIn()
            }, 500);

            const params = {
                month: (this.date.getMonth()+1),       // mois courant
                role_id: 14,
                ligne_id: data.ligne_id
            }
            this.$store.dispatch('getSoldeCourantLigneBudgetaire', params)
        },

        removeClassAfterAnimationCompletes(el, className) {
            let elStyles = window.getComputedStyle(this.inputContainerEl);
            setTimeout(function() {
                el.classList.remove(className);
            }, +elStyles.animationDuration.replace("s", "") * 1000);
        },
    
        filterArray(array, item, reverse = false) {
            if (reverse) {
                return array
                    .filter(word => this.compareTwoStrings(word, item))
                    .sort((a, b) => a.length - b.length);
            } else {
                return array
                    .filter(word => this.compareTwoStrings(word, item))
                    .sort((a, b) => b.length - a.length);
            }
        },
    
        removeDuplicatesFromArray(array) {
            return [...new Set(array.map(i => i))];
        },
    
        compareTwoStrings(string, subString) {
            let temp = string.split("", subString.length).join("");
            if (subString == temp) return subString;
        },
    }
}


